import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';
import DevotedImage from '../../assets/devoted.png';

const Page4 = () => {
    return (
        <Container
            maxWidth={false}
            sx={{
                marginTop: '50px',
                paddingTop: '50px',
                paddingBottom: '50px',
                backgroundColor: 'rgba(255, 250, 244, 1)',
                borderRadius: {
                    xs: '0px',
                    md: '20px'
                },
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: {
                    xs: 'auto',
                    md: '100vh',
                },
            }}
        >
            <Grid
                container
                spacing={4}
                alignItems="center"
            >
                {/* Left Column - Image */}
                <Grid
                    item xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center'
                    }}
                >
                    <Box
                        component="img"
                        src={DevotedImage}
                        alt="Devoted"
                        sx={{
                            width: '100%',
                            height: 'auto',
                            borderRadius: '20px',
                            objectFit: 'contain',
                        }}
                    />
                </Grid>

                {/* Right Column - Mission Content */}
                <Grid
                    item xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center'
                    }}
                >
                    <Box>
                        {/* OUR MISSION Title */}
                        <Box sx={{ marginBottom: '30px' }}>
                            <Typography
                                sx={{
                                    fontFamily: 'Quicksand, sans-serif',
                                    fontSize: {
                                        xs: '14px',
                                        md: '16px',
                                    },
                                    fontWeight: 500,
                                    letterSpacing: '0.2em',
                                    textAlign: 'left',
                                    color: 'rgba(0, 48, 135, 1)',
                                    marginBottom: '10px',
                                    textTransform: 'uppercase',
                                }}
                            >
                                OUR
                            </Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <Typography
                                    sx={{
                                        fontFamily: 'ClaireMurphy',
                                        fontSize: {
                                            xs: '40px',
                                            md: '60px',
                                        },
                                        fontWeight: 400,
                                        textAlign: 'left',
                                        color: 'rgba(0, 48, 135, 1)',
                                        textTransform: 'uppercase',
                                    }}
                                >
                                    MISSION
                                </Typography>
                                <Typography
                                    component="span"
                                    sx={{
                                        fontSize: {
                                            xs: '24px',
                                            md: '32px',
                                        },
                                        color: 'rgba(0, 48, 135, 1)',
                                    }}
                                >
                                    ✦
                                </Typography>
                            </Box>
                        </Box>

                        {/* Mission Statement */}
                        <Typography
                            sx={{
                                fontFamily: 'Quicksand, sans-serif',
                                fontSize: {
                                    xs: '16px',
                                    md: '18px',
                                },
                                fontWeight: 400,
                                lineHeight: {
                                    xs: '24px',
                                    md: '28px',
                                },
                                textAlign: 'left',
                                color: 'rgba(0, 48, 135, 1)',
                                marginBottom: '40px',
                            }}
                        >
                            Holistic well-being through quality products and personalized services. We ignite transformations for physical wellness, financial success, and personal growth.
                        </Typography>

                        {/* Core Values - Two Circles */}
                        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: '20px', marginTop: '40px' }}>
                            {/* Commitment Circle */}
                            <Box
                                sx={{
                                    position: 'relative',
                                    width: {
                                        xs: '100%',
                                        md: '200px',
                                    },
                                    height: {
                                        xs: '200px',
                                        md: '200px',
                                    },
                                    borderRadius: '50%',
                                    border: '2px solid rgba(0, 48, 135, 1)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    padding: '20px',
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontFamily: 'Quicksand, sans-serif',
                                        fontSize: {
                                            xs: '14px',
                                            md: '16px',
                                        },
                                        fontWeight: 500,
                                        textAlign: 'center',
                                        color: 'rgba(0, 48, 135, 1)',
                                        lineHeight: '22px',
                                    }}
                                >
                                    Commitment to top-tier wellness
                                </Typography>
                                <Typography
                                    component="span"
                                    sx={{
                                        position: 'absolute',
                                        top: '-8px',
                                        right: '10px',
                                        fontSize: '16px',
                                        color: 'rgba(0, 48, 135, 1)',
                                    }}
                                >
                                    ✦
                                </Typography>
                            </Box>

                            {/* Team Circle */}
                            <Box
                                sx={{
                                    position: 'relative',
                                    width: {
                                        xs: '100%',
                                        md: '200px',
                                    },
                                    height: {
                                        xs: '200px',
                                        md: '200px',
                                    },
                                    borderRadius: '50%',
                                    border: '2px solid rgba(0, 48, 135, 1)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    padding: '20px',
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontFamily: 'Quicksand, sans-serif',
                                        fontSize: {
                                            xs: '14px',
                                            md: '16px',
                                        },
                                        fontWeight: 500,
                                        textAlign: 'center',
                                        color: 'rgba(0, 48, 135, 1)',
                                        lineHeight: '22px',
                                    }}
                                >
                                    Weave together as a team
                                </Typography>
                                <Typography
                                    component="span"
                                    sx={{
                                        position: 'absolute',
                                        bottom: '-8px',
                                        right: '10px',
                                        fontSize: '16px',
                                        color: 'rgba(0, 48, 135, 1)',
                                    }}
                                >
                                    ✦
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Container>
    );
};

export default Page4;
